import style from './Main.module.scss';
import { IChildren } from '../layout/index';
import { useContext } from 'react';
import { AuthContext } from '../../context/Auth';
import { ContainerMain } from './styled';

export default function Main(props: IChildren) {
    const {state} = useContext(AuthContext);

    return(
        <ContainerMain $open={state?.menu.status}>
            {props.children}
        </ContainerMain>
    )
}
